import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { RefundsService } from "../../../../auth/service/refunds.service";
import moment from "moment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-refunds-user-list",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./refunds-user-list.component.html",
  styleUrls: ["./refunds-user-list.component.scss"],
})

export class RefundsUserListComponent implements OnInit {
  @ViewChild("viewRefunds") viewRefunds: ElementRef;
  public contentHeader: IContentHeader;
  public refunds: any;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public searchStatus: number = 10;
  public currentRefunds: any;
  public me: ICurrentUser;
  private idParam: number;
  public refundsFiltered: any = [];
  public showModalAdd: boolean = false;

  constructor(
    public _refundsService: RefundsService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    public activatedRoute: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.YOUR_REQUESTED_REFUNDS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.YOUR_REQUESTED_REFUNDS,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.me = await this._authenticationService.getCurrentUser();
    await this.loadRefunds();
    this._utilService.hideLoading();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadRefunds() {
    if (this._refundsService.mineRefund && this._refundsService.mineRefund.length > 1) {
      this.refunds = this._refundsService.mineRefund;
    } else {
      this.refunds = await this._refundsService.getMineRefund();
    }
    this.activatedRoute.queryParams.subscribe(async (params) => {
      this.idParam = Number(params.id);
      if (this.idParam) {
        this.currentRefunds = await this.refunds.find((ref: any) => ref.id == this.idParam);
        this.openModal(this.viewRefunds, this.currentRefunds);
      }
    });
    this.refunds = this.refunds.sort((a: any, b: any) => {
      a = moment(a.date);
      b = moment(b.date);
      return a > b ? -1 : a < b ? 1 : 0;
    });

    const approved: string = await this._utilService.translate("APPROVED_FEMALE_SINGULAR");
    const pending: string = await this._utilService.translate("PENDING");
    const notApproved: string = await this._utilService.translate("NOT_APPROVED_SINGULAR");
    this.refunds.map((item: any) => {
      if (item.status === 1) {
        item.enabled_label = approved;
      } else if (item.status === 2) {
        item.enabled_label = notApproved;
      } else {
        item.enabled_label = pending;
      }
    });

    this.filterRefunds();
  }

  filterRefunds() {
    let items: any = this.refunds;
    if (!items || items.length < 1) return false;

    items = items.filter((item: any) => item.user_hash.toLowerCase().includes(this.me.hash));

    items.sort((a: any, b: any) => (a.from < b.from ? 1 : a.from > b.from ? -1 : 0));

    items = items.map((item: any) => {
      item.amount = this._utilService.removeDotsFromNumber(item.amount.toString());
      return item;
    });

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) => item.amount.includes(keywords));
    }

    if (this.searchStatus < 3) {
      items = items.filter((item: any) => Number(item.status) === Number(this.searchStatus));
    }

    this.refundsFiltered = items;
  }

  openModal(modal, refunds) {
    this._modalService.open(modal, {
      centered: true,
      size: "sm",
    });
    this.currentRefunds = JSON.parse(JSON.stringify(refunds));
  }

  openFile(file: any) {
    return this._utilService.getFile(file);
  }
}
